import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@/contexts/AuthContext';
import { useConsumerAvatar } from '@/hooks/useConsumerAvatar';
import { PhotoUploadSheet } from '@/components/common/PhotoUploadSheet';

/**
 * Cabeçalho de identidade do cliente: avatar (com selo de câmara + bottom sheet,
 * via PhotoUploadSheet partilhado) + nome + nível.
 */
export function ConsumerAvatarCard() {
  const { t } = useTranslation();
  const { consumer } = useAuthContext();
  const { uploadAvatar, removeAvatar, isUploading, isRemoving } = useConsumerAvatar();

  const inicial = consumer?.nome?.charAt(0)?.toUpperCase() || '?';

  return (
    <div className="mb-6">
      <PhotoUploadSheet
        imageUrl={consumer?.avatar_url}
        fallback={inicial}
        onPick={uploadAvatar}
        onRemove={removeAvatar}
        busy={isUploading || isRemoving}
        canRemove={!!consumer?.avatar_url}
        caption={
          <div className="text-center">
            <div className="text-lg font-bold text-foreground">{consumer?.nome || ''}</div>
            <div className="text-sm text-muted-foreground">{t('consumer.levelLabel', { level: 0 })}</div>
          </div>
        }
      />
    </div>
  );
}
